import { Button, TextInputField } from "evergreen-ui";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { saveData } from "../../../Utils/localStorage";
import styles from "./createAccount.module.css";
import { useSelector } from "react-redux";
import { IMAGE_PATH, PRODUCT } from "../../../Utils/variables";

export const CreateAccount = () => {
  const { isLogin } = useSelector((state) => state.auth);
  const [isvisible, setIsVisible] = useState(false);
  const [liscense, setLiscense] = useState("");
  const navigate = useNavigate();
  const handleCreateAccount = (e) => {
    e.preventDefault();
    if (liscense == "") {
      toast.error("Please enter trade license number");
    } else {
      setIsVisible(true);
      fetch(process.env.REACT_APP_API_URL + "/api/vendor/licenseVendor", {
        method: "POST",
        body: JSON.stringify({ trade_license_number: liscense }),
        headers: { "content-type": "application/json" },
      })
        .then((d) => d.json())
        .then((res) => {
          setIsVisible(false);
          const response = res.response
          const emailsArr = response.user_info.map(user => user.email?.toLowerCase())
          const vendorEmail = response?.vendor_info?.vendor_email?.toLowerCase()
          if(!emailsArr.includes(vendorEmail)){
            emailsArr.push(vendorEmail)
          }
          if (res.status == true) {
            saveData("email", emailsArr.join(','));
            saveData("LicenseNumber", res.response.vendor_info.trade_license_number);
            navigate("/alreadyregistered");
          } else {
            saveData("tradeLicenseNumber", liscense);
            navigate("/vendordetails");
          }
        })
        .catch((err) => {
          setIsVisible(false);
          console.log(err);
        });
    }
  };

  useEffect(() => {
    document.title = PRODUCT + " - Create Account";
    if (isLogin) {
      navigate("/rfqs");
    }
  }, []);
  return (
    <>
      <div
        className={styles.mainDivCA}
        style={{
          backgroundImage: `url(${IMAGE_PATH}loginLeftBg.svg),
    url(${IMAGE_PATH}createAccountRightBg.svg)`,
        }}
      >
        <div className={styles.middleDivCA}>
          <div>
            <h1>CREATE AN ACCOUNT</h1>
            <p>
              To create an account enter your<b> TRADE LICENSE NUMBER</b>
            </p>
          </div>
          <div className={styles.centerDivCA}>
            <TextInputField
              className={styles.inputDiv}
              label="Trade License Number"
              placeholder="Enter Trade License Number"
              value={liscense}
              onChange={(e) => setLiscense(e.target.value.trim())}
            />
            <div>
              {!isvisible ? (
                <Button
                  onClick={handleCreateAccount}
                  className={styles.nextBtnCA}
                  id="poppinFontLogin"
                >
                  NEXT
                </Button>
              ) : (
                <Button
                  onClick={handleCreateAccount}
                  className={styles.nextBtnCA}
                  id="poppinFontLogin"
                >
                  <i
                    className="fa fa-spinner fa-spin "
                    style={{ color: "white", marginRight: "10px" }}
                  ></i>
                  NEXT
                </Button>
              )}
            </div>
          </div>
        </div>
        <ToastContainer autoClose={5000} />
      </div>
    </>
  );
};
